import * as actionTypes from '../action-types';
import {
  WatcherSearchQueryParams,
  NewWatcherFromSuggestionQueryParams,
} from '../../watchers.types';
import { WatchersActions } from '../actions';

type Reducer = {
  [key: string]: WatcherSearchQueryParams | NewWatcherFromSuggestionQueryParams;
};

const defaultState: Reducer = {};

export function watchersQueriesMapReducer(
  state: Reducer = defaultState,
  action: WatchersActions,
) {
  switch (action.type) {
    case actionTypes.SET_WATCHERS: {
      const { watchers } = action.payload;
      return watchers.reduce(
        (acc: { [key: string]: WatcherSearchQueryParams }, watcher) => {
          acc[watcher.key] = watcher.searchQuery;
          return acc;
        },
        {},
      );
    }
    case actionTypes.CREATE_WATCHER: {
      const { watcher } = action.payload;
      return { ...state, [watcher.key]: watcher.searchQuery };
    }
    case actionTypes.DELETE_WATCHER: {
      const { watcherKey } = action.payload;
      const { [watcherKey]: removed, ...rest } = state;
      return rest;
    }
    case actionTypes.SET_WATCHER: {
      const { watcher } = action.payload;
      return { ...state, [watcher.key]: watcher.searchQuery };
    }
    default: {
      return state;
    }
  }
}
